// App-wide toast container — bridges sonner with ThemeProvider's resolved theme.
import { Toaster } from 'sonner';
import { useTheme } from '@/components/ThemeProvider';

export function AppToaster() {
  const { resolvedTheme } = useTheme();
  return <Toaster theme={resolvedTheme} position="bottom-right" richColors closeButton />;
}
